export default defineNuxtRouteMiddleware(to => {
	if (!__WEBSHOP__) return;

	const {getUrlSegments} = useUrl();
	const routeSegments = getUrlSegments(to.path, {ignoreLang: true});

	if (routeSegments[0] !== 'webshop' || routeSegments[1] !== 'copy-cart') return;

	const {getAppUrl} = useApiRoutes({route: to});
	const identificator = to.query?.identificator;

	return navigateTo({
		path: getAppUrl('webshop_shopping_cart'),
		query: identificator ? {identificator: String(identificator)} : {errorcode: 'copy_cart_failed'},
	});
});
